import { useEffect } from 'react';
import { useExperimentContext } from './useExperimentContext';
import { CONTROL } from '../../experiments/experiments';
import type { ExperimentCode, VariantOf } from '../../experiments/experiments';

/**
 * Returns the server-assigned variant for `code` for the current payment,
 * or 'control' when this payment is not in the experiment. Fires a
 * session-deduped exposure event (post-commit) only when an assignment is
 * present (control-bucketed included).
 */
export function useExperiment<C extends ExperimentCode>(code: C): VariantOf<C> {
  const { getVariant, fireExposure } = useExperimentContext();
  const assigned = getVariant(code);

  useEffect(() => {
    if (assigned !== undefined) {
      fireExposure(code, assigned);
    }
  }, [code, assigned, fireExposure]);

  return (assigned ?? CONTROL) as VariantOf<C>;
}
